(() => {
  const parseFinish = (value) => {
    const match = String(value).trim().match(/^(.*?)\s*\(([^)]+)\)\s*$/);
    return match
      ? { family: match[1].trim(), treatment: match[2].trim() }
      : { family: String(value).trim(), treatment: '' };
  };

  const unique = (values) => [...new Set(values)];
  const displayTreatment = (value) => String(value).replace(/\b\w/g, (character) => character.toUpperCase());

  const initialize = (selector) => {
    if (selector.dataset.initialized === 'true') return;
    const variantSelects = selector.closest('variant-selects');
    const source = variantSelects?.querySelector('[data-finish-source]');
    const inputs = [...(source?.querySelectorAll('input[type="radio"]') || [])];
    if (!inputs.length) return;

    selector.dataset.initialized = 'true';
    const familyGrid = selector.querySelector('[data-dependent-finish-families]');
    const treatments = selector.querySelector('[data-dependent-finish-treatments]');
    const treatmentButtons = selector.querySelector('[data-dependent-finish-treatment-buttons]');
    const fixedTreatment = selector.querySelector('[data-dependent-finish-fixed]');
    const selectedOutput = selector.querySelector('[data-dependent-finish-selected]');

    const records = inputs.map((input) => ({ input, ...parseFinish(input.value) }));
    const families = unique(records.map(({ family }) => family));

    const choose = (record) => {
      if (!record || record.input.checked) return;
      record.input.click();
    };

    const render = () => {
      const selected = records.find(({ input }) => input.checked) || records[0];
      selectedOutput.textContent = selected.family;
      familyGrid.replaceChildren(...families.map((family) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'dependent-finish__button';
        button.textContent = family;
        button.setAttribute('aria-pressed', String(family === selected.family));
        button.addEventListener('click', () => {
          const candidates = records.filter((record) => record.family === family);
          choose(candidates.find(({ treatment }) => treatment === selected.treatment) || candidates[0]);
        });
        return button;
      }));

      const familyRecords = records.filter(({ family }) => family === selected.family);
      const familyTreatments = unique(familyRecords.map(({ treatment }) => treatment).filter(Boolean));
      const hasTreatmentChoice = familyTreatments.length > 1;
      treatments.hidden = !hasTreatmentChoice;
      fixedTreatment.hidden = hasTreatmentChoice || familyTreatments.length !== 1;
      fixedTreatment.textContent = familyTreatments.length === 1 ? `Treatment: ${displayTreatment(familyTreatments[0])}` : '';
      treatmentButtons.replaceChildren();
      if (hasTreatmentChoice) {
        familyTreatments.forEach((treatment) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'dependent-finish__button dependent-finish__button--treatment';
          button.textContent = displayTreatment(treatment);
          button.setAttribute('aria-pressed', String(treatment === selected.treatment));
          button.addEventListener('click', () => choose(familyRecords.find((record) => record.treatment === treatment)));
          treatmentButtons.appendChild(button);
        });
      }
    };

    source.addEventListener('change', render);
    render();
  };

  const initializeAll = () => document.querySelectorAll('[data-dependent-finish]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  else initializeAll();
  document.addEventListener('product-info:loaded', initializeAll);
  document.addEventListener('shopify:section:load', initializeAll);
  new MutationObserver(initializeAll).observe(document.documentElement, { childList: true, subtree: true });
})();
